/* eslint-disable jsx-a11y/img-redundant-alt */
/* eslint-disable no-undef */
/* eslint-disable react/no-unescaped-entities */
/* eslint-disable no-unused-vars */

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {
  Avatar_16,
  Avatar_02,
  Avatar_05,
  Avatar_09,
  Avatar_10,
} from "../../../Routes/ImagePath/index";

import { Link } from "react-router-dom";
import Select from "react-select";
import { useTranslation } from "react-i18next";

import React, { useState, useEffect } from "react";

import AuthUser from "../../AuthUser";


import { Table } from "antd";

import Swal from "sweetalert2";

const CertificadosDoColaboradorModal = ({ utilizador }) => {
  const { t } = useTranslation();

  // eslint-disable-next-line no-unused-vars
  const {
    http,
    url_root,
    user,
    user_permissoes,
    verificarPermissao,
    getMissao,
  } = AuthUser();

  const [certificacoes, setCertificacoes] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        await verCertificações();
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [utilizador]);

  const verCertificações = async () => {
    try {
      setLoading(true); // Set loading to true when the request starts

      const formData = new FormData();
      formData.append("formando_id", utilizador?.id);

      const response = await http.post(
        "/certificados-do-colaborador",
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );

      setCertificacoes(response.data.certificacoes);

      setLoading(false);
    } finally {
      setLoading(false); // Set loading to false when the request is complete (either success or error)
    }
  };

  const today = new Date();

  const calculateExpirationInfo = (trainingExpiration) => {
    const expirationDate = new Date(trainingExpiration);
    expirationDate.setFullYear(expirationDate.getFullYear());

    const timeDiff = expirationDate.getTime() - today.getTime();
    const daysToExpire = Math.ceil(timeDiff / (1000 * 3600 * 24));

    const status =
      daysToExpire > 0 && daysToExpire <= 90
        ? "Prestes a expirar"
        : daysToExpire > 0
        ? "Valido"
        : "Expirado";

    return { daysToExpire, status };
  };


  const columns = [
      {
        title: "#",
        dataIndex: "index",
        key: "index",
        render: (text, record, index) => index + 1,
      },
      {
        title: t("Colaborador"),
        dataIndex: "sigla",
        render: (text, record) => (
          <div
            className="d-flex align-items-center p-2 mb-2"
            style={{
              borderRadius: "8px",
              gap: "10px",
            }}
          >
            <div
              style={{
                width: "45px",
                height: "45px",
                borderRadius: "50%",
                backgroundColor: "#dee2e6",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: "20px",
              }}
            >
              <img
                src={url_root + "/storage/" + record?.formando?.fotografia}
                className="avatar rounded-circle"
                width={32}
                height={32}
                alt=""
              />
            </div>
            <div style={{ flexGrow: 1 }}>
              <div style={{ fontWeight: "bold", color: "#888" }}>
                {record?.formando?.name}
              </div>
              <div style={{ fontSize: "12px", color: "#6c757d" }}>
                {record?.formando?.cargo?.designacao}
              </div>
            </div>
          </div>
        ),
        sorter: (a, b) => a.sigla.length - b.sigla.length,
      },
      {
        title: "Certificação",
        dataIndex: "sigla",
        render: (text, record) => (
          <div
            className="d-flex align-items-center p-2 mb-2"
            style={{
              borderRadius: "8px",
              gap: "10px",
            }}
          >
            <div
              style={{
                width: "45px",
                height: "45px",
                borderRadius: "20%",
                backgroundColor: "#dee2e6",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: "20px",
              }}
            >
              <img
                src={url_root + "/storage/cursos/" + record?.curso?.imagem}
                className="avatar rounded-square"
                width={32}
                height={32}
                alt=""
              />
            </div>
            <div style={{ flexGrow: 1 }}>
              <div style={{ fontWeight: "bold", color: "#888" }}>
                {record?.curso?.designacao}
              </div>
              <div style={{ fontSize: "12px", color: "#6c757d" }}>
                {" Emissão: "}
                {new Date(record.data_emissao).toLocaleDateString()}
                {" - Expira: "}
                {new Date(record.data_expiracao).toLocaleDateString()}
              </div>
            </div>
            <div className="d-flex align-items-center gap-3">
              <a
                href={url_root + "/storage/certificados/" + record?.ficheiro}
                target="blank"
              >
                <i
                  width="40"
                  height="40"
                  className="fa fa-file-pdf"
                  alt="File icon"
                ></i>
              </a>
            </div>
          </div>
        ),
        sorter: (a, b) => a.sigla.length - b.sigla.length,
      },
      {
        title: "Nivel",
        dataIndex: "nivel",
        render: (text, record) => (
          <>
            <span>
              {record.curso?.nivel == 1
                ? "Básico"
                : record.curso?.nivel == 2
                ? "Intermédio"
                : record.curso?.nivel == 3
                ? "Avançado"
                : "Padrão"}
            </span>
          </>
        ),
        sorter: (a, b) => a.nivel.length - b.nivel.length,
      },
      {
        title: "Duração",
        dataIndex: "duracao",
        render: (text, record) => (
          <>
            <span>
              {record.curso?.expira == 1
                ? record.curso?.expiracao +
                  " " +
                  (record.curso?.expira_unidade == 1 ? "Mes(es)" : "Ano(s)")
                : "Não Expira"}
            </span>
          </>
        ),
        sorter: (a, b) => a.duracao.length - b.duracao.length,
      },
      {
        title: t("Estado"),
        dataIndex: "estado",
        render: (text, record) => (
          <>
            <span
              className={`badge ${
                calculateExpirationInfo(record?.data_expiracao)?.status ==
                "Expirado"
                  ? "badge-danger"
                  : calculateExpirationInfo(record?.data_expiracao)?.status ==
                    "Prestes a expirar"
                  ? "badge-warning"
                  : "badge-success"
              }`}
            >
              {calculateExpirationInfo(record?.data_expiracao)?.status}
            </span>
          </>
        ),
        sorter: (a, b) => a.estado.length - b.estado.length,
      },
      {
        title: "Dias para Expirar",
        dataIndex: "designacao",
        render: (text, record) => (
          <>
            {" "}
            {calculateExpirationInfo(record?.data_expiracao)?.status ==
            "Expirado" ? (
              <span className="text-danger">Expirado</span>
            ) : (
              <span>
                {calculateExpirationInfo(record?.data_expiracao)?.daysToExpire}{" "}
                dias
              </span>
            )}
          </>
        ),
  
        sorter: (a, b) => a.designacao.length - b.designacao.length,
      }
    ];

  return (
    <>
      {/* Add Task Modal */}
      <div
        id="certificados_do_colaborador_modal"
        className="modal custom-modal fade modal-xl"
        role="dialog"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title" onClick={() => verCertificações()}>
                <i className="fa fa-recycle"></i>
                {loading ? (
                  <i className="fa fa-spinner fa-spin me-2"></i>
                ) : (
                  t(" Certificados do colaborador - " + utilizador?.name)
                )}
              </h4>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                id="closeButton30"
              >
                ×
              </button>
            </div>
            <div className="modal-body">

              <Table
                className="table-striped"
                style={{ overflowX: "auto" }}
                columns={columns}
                dataSource={certificacoes}
                rowKey={(record) => record.id}
              />

            </div>
          </div>
        </div>
      </div>
      {/* /Add Task Modal */}
    </>
  );
};

export default CertificadosDoColaboradorModal;
